import React, { type FC } from 'react';

import { IconProps } from '.';

export const GoogleIcon: FC<IconProps> = ({ className = '' }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4998 8.18164V12.0544H15.8816C15.6452 13.2998 14.9361 14.3544 13.8724 15.0635L17.1179 17.5817C19.0088 15.8363 20.0997 13.2726 20.0997 10.2272C20.0997 9.51812 20.0361 8.83623 19.9179 8.18175L10.4998 8.18164Z"
        fill="#4285F4"
      />
      <path
        d="M4.89568 11.9033L4.16371 12.4636L1.57275 14.4818C3.2182 17.7454 6.59068 20 10.4997 20C13.1997 20 15.4633 19.1091 17.1179 17.5818L13.8724 15.0636C12.9815 15.6636 11.8451 16.0273 10.4997 16.0273C7.89976 16.0273 5.69073 14.2728 4.89976 11.9091L4.89568 11.9033Z"
        fill="#34A853"
      />
      <path
        d="M1.57265 5.51807C0.890868 6.86347 0.5 8.38167 0.5 9.99982C0.5 11.618 0.890868 13.1362 1.57265 14.4816C1.57265 14.4906 4.89998 11.8998 4.89998 11.8998C4.69998 11.2998 4.58177 10.6634 4.58177 9.99972C4.58177 9.336 4.69998 8.69967 4.89998 8.09968L1.57265 5.51807Z"
        fill="#FBBC05"
      />
      <path
        d="M10.4999 3.98182C11.9727 3.98182 13.2818 4.49089 14.3272 5.47272L17.1908 2.60912C15.4545 0.990971 13.2 0 10.4999 0C6.59089 0 3.2182 2.24545 1.57275 5.51819L4.89998 8.10001C5.69084 5.73635 7.89996 3.98182 10.4999 3.98182Z"
        fill="#EA4335"
      />
    </svg>
  );
};
